import {removeUrlSearchParam} from 'src/utils/remove-url-search-param';

import {
    MODAL_LEARN_ABOUT_PLAN,
    OPEN_CHECKLIST_QUERY_PARAM,
    SKIP_SURVEY_PENDING_OPEN_CHECKLIST_KEY,
} from './constants';
import {CHECKLIST_ITEM_IDS} from './modal';

import type {NextRouter} from 'next/router';

export function setSkipSurveyPendingOpenChecklist(): void {
    if (typeof window === 'undefined') return;
    window.sessionStorage.setItem(SKIP_SURVEY_PENDING_OPEN_CHECKLIST_KEY, '1');
}

export function hasSkipSurveyPendingOpenChecklist(): boolean {
    if (typeof window === 'undefined') return false;
    return window.sessionStorage.getItem(SKIP_SURVEY_PENDING_OPEN_CHECKLIST_KEY) === '1';
}

export function consumeSkipSurveyPendingOpenChecklist(): boolean {
    if (typeof window === 'undefined') return false;
    const isPending = hasSkipSurveyPendingOpenChecklist();
    if (isPending) {
        window.sessionStorage.removeItem(SKIP_SURVEY_PENDING_OPEN_CHECKLIST_KEY);
    }
    return isPending;
}

export function isChecklistFullyComplete(completedItemCount: number): boolean {
    return completedItemCount >= CHECKLIST_ITEM_IDS.length;
}

export interface ChecklistAutoOpenMountResult {
    openedLearnAboutPlanFromUrl: boolean;
    shouldAutoOpenChecklist: boolean;
}

export function initializeChecklistAutoOpenOnMount(
    router: NextRouter,
): ChecklistAutoOpenMountResult {
    if (typeof window === 'undefined') {
        return {openedLearnAboutPlanFromUrl: false, shouldAutoOpenChecklist: false};
    }

    const params = new URLSearchParams(window.location.search);

    if (params.get('modal') === MODAL_LEARN_ABOUT_PLAN) {
        removeUrlSearchParam(router, 'modal');
        return {openedLearnAboutPlanFromUrl: true, shouldAutoOpenChecklist: false};
    }

    const hadPendingChecklist = hasSkipSurveyPendingOpenChecklist();
    const hasOpenChecklistParam = params.has(OPEN_CHECKLIST_QUERY_PARAM);

    if (!hasOpenChecklistParam && !hadPendingChecklist) {
        return {openedLearnAboutPlanFromUrl: false, shouldAutoOpenChecklist: false};
    }

    if (hasOpenChecklistParam) {
        removeUrlSearchParam(router, OPEN_CHECKLIST_QUERY_PARAM);
    }

    return {openedLearnAboutPlanFromUrl: false, shouldAutoOpenChecklist: true};
}

export interface DeferredChecklistAutoOpenResult {
    shouldOpenExpanded: boolean;
    consumedPendingSessionFlag: boolean;
}

export function resolveDeferredChecklistAutoOpen(
    completedItemCount: number,
): DeferredChecklistAutoOpenResult {
    if (isChecklistFullyComplete(completedItemCount)) {
        return {
            shouldOpenExpanded: false,
            consumedPendingSessionFlag: consumeSkipSurveyPendingOpenChecklist(),
        };
    }

    return {
        shouldOpenExpanded: true,
        consumedPendingSessionFlag: false,
    };
}
